import { render } from "./NodeGroup.vue?vue&type=template&id=4bfe69b6&scoped=true&ts=true"
import script from "./NodeGroup.vue?vue&type=script&lang=ts"
export * from "./NodeGroup.vue?vue&type=script&lang=ts"

import "./NodeGroup.vue?vue&type=style&index=0&id=4bfe69b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfe69b6"]])

export default __exports__